import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import { selectRoomId } from '../features/appSlice';
import { useSelector } from 'react-redux';
import ChatInput from './ChatInput';
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';
import { db } from '../firebase';
// import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import Message from './Message';


function Chat() {
 const chatRef = useRef(null);

const roomId = useSelector(selectRoomId)
const [roomDetials]= useDocument(
    roomId && db.collection('rooms').doc(roomId)
)
const [roomMessages,loading]= useCollection(
    roomId &&
        db
        .collection('rooms')
        .doc(roomId)
        .collection('messages')
        .orderBy('timestamp','asc')
);
 useEffect(()=>{
    chatRef?.current?.scrollIntoView();
 },[roomId,loading])

  return (
    
   <ChatContainer>
         
        {roomDetials && roomMessages && (
            <>
      
            <Header>
                <HeaderLeft>
                    <h4><strong><Groups2OutlinedIcon/>{roomDetials?.data().name}</strong>
                    </h4>
                    <StarBorderOutlinedIcon/>
                </HeaderLeft>
        
                <HeaderRight>
                    <p>
                    <abbr title={roomDetials?.data().name}><InfoOutlinedIcon/> Details</abbr> 
                    </p>
                </HeaderRight>
        
            </Header>
                <ChatMessages> 
                       {roomMessages?.docs.map(doc=>{
                        const {message, timestamp, user, userImage}= doc.data();
                        return (
                            <Message
                                key={doc.id}
                                message={message}
                                timestamp={timestamp}
                                user={user}
                                userImage={userImage}
                            />
                        )
                       })}
                       <ChatBottom ref={chatRef}/>
                </ChatMessages>
        
                <ChatInput 
                chatRef={chatRef}
                channelName={roomDetials?.data().name}
                 channelId={roomId}
        
                />
            </>
        )}
    
   </ChatContainer>
  )
}

export default Chat;

const ChatBottom= styled.div`
 padding-bottom: 200px;
`;

const Header= styled.div`
display: flex;
justify-content: space-between;
padding: 20px;
border-bottom: 1px solid lightgray;
`;

const ChatMessages = styled.div``;


const HeaderLeft= styled.div`
display: flex;
align-items: center;
>h4 {
    display: flex;
    text-transform: lowercase;
    margin-right: 10px;
}
 > h4 > .MuiSvgIcon-root {
    margin-left: 20px;
    font-size: 10px;

}
>h4> strong>  .MuiSvgIcon-root {
    
font-size: 20px;
margin-right: 10px;
}
`;
const HeaderRight= styled.div`
> p {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: default !important;
}
> p > abbr> .MuiSvgIcon-root{
    margin-right:5px !important;

    font-size: 16px;
    border-bottom: none !important;
    
}
>p>abbr{
    display: flex;
    border: none;
text-decoration: none;
}
`;

const ChatContainer = styled.div`
flex:0.7;
flex-grow: 1;
overflow-y: scroll;
margin-top: 60px;

`;
